/**
 * Free sample handling.
 *
 * 1. Adds samples from the cart page, where the sample list renders inside the cart
 *    <form> and a nested product form isn't possible.
 * 2. Locks every sample list as soon as one is added, so the free sample limit can't
 *    be beaten by clicking several samples before the list re-renders.
 *
 * The server rendered list (snippets/add-samples.liquid) remains the source of truth
 * for which samples are available; this only stops interaction until it re-renders.
 */
(function () {
  var LIST_SELECTOR = '.samples';
  var BUSY_CLASS = 'samples--busy';

  var SAMPLE_PROPERTIES = {
    sampleTitle: '_sample_title',
    sampleShortDescription: '_sample_short_description',
    sampleSize: '_sample_size',
    sampleOptionName: '_sample_option_name',
    sampleOptionValue: '_sample_option_value',
    sampleVariantTitle: '_sample_variant_title'
  };

  function setBusy(isBusy) {
    document.querySelectorAll(LIST_SELECTOR).forEach(function (list) {
      list.classList.toggle(BUSY_CLASS, isBusy);
    });
  }

  function sampleProperties(button) {
    var properties = { _sample: 'true' };

    Object.keys(SAMPLE_PROPERTIES).forEach(function (key) {
      var value = button.dataset[key];
      if (value) {
        properties[SAMPLE_PROPERTIES[key]] = value;
      }
    });

    return properties;
  }

  function addSample(button) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: button.dataset.variantId,
          quantity: 1,
          properties: sampleProperties(button)
        }]
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to add sample to cart');
      }
      window.location.reload();
    }).catch(function (error) {
      console.error(error);
      setBusy(false);
      button.removeAttribute('disabled');
      button.classList.remove('loading');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sample-add]');
    if (!button || button.hasAttribute('disabled')) {
      return;
    }

    event.preventDefault();
    setBusy(true);
    button.setAttribute('disabled', 'disabled');
    button.classList.add('loading');
    addSample(button);
  });

  // Sample adds everywhere else go through a quick-buy product form.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.querySelector && form.querySelector('input[name="properties[_sample]"]')) {
      setBusy(true);
    }
  }, true);
})();
